/**
 * FormData -> API gövdesi dönüştürücü.
 *
 * Form alanları her zaman string gönderir; backend ise DateOnly?, int, bool
 * gibi tiplere deserialize eder. Boş string ("") nullable alanlara
 * çevrilemediği için tüm DTO 400 (dto field is required) hatasıyla düşer.
 *
 * - "" -> null (boş bırakılan tarih/metin alanları nullable alanlara bağlanır)
 * - booleans listesindeki alanlar: checkbox "on" -> true, yoksa false
 * - numbers listesindeki alanlar: string -> number
 */
export function parseFormData(
  formData: FormData,
  options?: { booleans?: string[]; numbers?: string[] },
): Record<string, unknown> {
  const obj: Record<string, unknown> = Object.fromEntries(formData);

  for (const key of Object.keys(obj)) {
    if (obj[key] === "") obj[key] = null;
  }

  for (const key of options?.booleans ?? []) {
    obj[key] = obj[key] === "on" || obj[key] === "true";
  }

  for (const key of options?.numbers ?? []) {
    const value = obj[key];
    if (value === null || value === undefined) continue;
    const parsed = Number(value);
    obj[key] = Number.isNaN(parsed) ? null : parsed;
  }

  return obj;
}
